module.exports = __webpack_public_path__ + "static/media/banner-1.69550b7a.jpg";